export const letterE = {
  nouns: [
    {"corner": ["Ecke", "Ecken", "die", "die", "f"]},
    {"wife": ["Ehefrau", "Ehefrauen", "die", "die", "f"]},
    {"husband": ["Ehemann", "Ehemänner", "der", "die", "m"]},
    {"egg": ["Ei", "Eier", "das", "die", "n"]},
    {"entrance": ["Eingang", "Eingänge", "der", "die", "m"]},
    {"invitation": ["Einladung", "Einladungen", "die", "die", "f"]},
    {"admission": ["Eintritt", "Eintritte", "der", "die", "m"]},
    {"single room": ["Einzelzimmer", "Einzelzimmer", "das", "die", "n"]},
    {"parents": ["Eltern", "Eltern", "die", "die", "p"]},
    {"email": ["E-Mail", "E-Mails", "die", "die", "f"]},
    {"recipient": ["Empfänger", "Empfänger", "der", "die", "m"]},
    {"end": ["Ende", "Enden", "das", "die", "n"]},
    {"apology": ["Entschuldigung", "Entschuldigungen", "die", "die", "f"]},
    {"result": ["Ergebnis", "Ergebnisse", "das", "die", "n"]},
    {"adult": ["Erwachsene", "Erwachsenen", "der", "die", "m"]},
    {"meal": ["Essen", "Essen", "das", "die", "n"]},
    {"experience": ["Erfahrung", "Erfahrungen", "die", "die", "f"]},
    {"married couple": ["Ehepaar", "Ehepaare", "das", "die", "n"]},
    {"purchase": ["Einkauf", "Einkäufe", "der", "die", "m"]},
    {"elephant": ["Elefant", "Elefanten", "der", "die", "m"]},
    {"engine": ["Motor", "Motoren", "der", "die", "m"]},
    {"example": ["Beispiel", "Beispiele", "das", "die", "n"]},
    {"economy": ["Wirtschaft", "Wirtschaften", "die", "die", "f"]},
    {"education": ["Bildung", "Bildungen", "die", "die", "f"]},
    {"electricity": ["Strom", "Strom", "der", "die", "m"]},
    {"emotion": ["Gefühl", "Gefühle", "das", "die", "n"]},
    {"energy": ["Energie", "Energien", "die", "die", "f"]},
    {"engineer": ["Ingenieur", "Ingenieure", "der", "die", "m"]},
    {"envelope": ["Umschlag", "Umschläge", "der", "die", "m"]},
    {"environment": ["Umwelt", "Umwelten", "die", "die", "f"]},
    {"error": ["Fehler", "Fehler", "der", "die", "m"]},
    {"event": ["Ereignis", "Ereignisse", "das", "die", "n"]},
    {"evening": ["Abend", "Abende", "der", "die", "m"]},
    {"everyone": ["Jede", "Jeden", "der", "die", "m"]},
    {"exam": ["Prüfung", "Prüfungen", "die", "die", "f"]},
    {"exercise": ["Übung", "Übungen", "die", "die", "f"]},
    {"exit": ["Ausgang", "Ausgänge", "der", "die", "m"]},
    {"expert": ["Experte", "Experten", "der", "die", "m"]},
    {"explanation": ["Erklärung", "Erklärungen", "die", "die", "f"]},
    {"expression": ["Ausdruck", "Ausdrücke", "der", "die", "m"]},
    {"eye": ["Auge", "Augen", "das", "die", "n"]},
    {"ear": ["Ohr", "Ohren", "das", "die", "n"]},
    {"earth": ["Erde", "Erden", "die", "die", "f"]},
    {"east": ["Osten", "Osten", "der", "die", "m"]},
    {"enemy": ["Feind", "Feinde", "der", "die", "m"]}
  ],
  verbs: [
    {"to shop": ["einkaufen", "kaufe ein", "kaufst ein", "kauft ein", "kauft ein", "kauft ein", "kaufen ein", "kauft ein", "kaufen ein", "kaufen ein"]},
    {"to invite": ["einladen", "lade ein", "lädst ein", "lädt ein", "lädt ein", "lädt ein", "laden ein", "ladet ein", "laden ein", "laden ein"]},
    {"to get in": ["einsteigen", "steige ein", "steigst ein", "steigt ein", "steigt ein", "steigt ein", "steigen ein", "steigt ein", "steigen ein", "steigen ein"]},
    {"to recommend": ["empfehlen", "empfehle", "empfiehlst", "empfiehlt", "empfiehlt", "empfiehlt", "empfehlen", "empfehlt", "empfehlen", "empfehlen"]},
    {"to end": ["enden", "ende", "endest", "endet", "endet", "endet", "enden", "endet", "enden", "enden"]},
    {"to excuse": ["entschuldigen", "entschuldige", "entschuldigst", "entschuldigt", "entschuldigt", "entschuldigt", "entschuldigen", "entschuldigt", "entschuldigen", "entschuldigen"]},
    {"to explain": ["erklären", "erkläre", "erklärst", "erklärt", "erklärt", "erklärt", "erklären", "erklärt", "erklären", "erklären"]},
    {"to allow": ["erlauben", "erlaube", "erlaubst", "erlaubt", "erlaubt", "erlaubt", "erlauben", "erlaubt", "erlauben", "erlauben"]},
    {"to tell": ["erzählen", "erzähle", "erzählst", "erzählt", "erzählt", "erzählt", "erzählen", "erzählt", "erzählen", "erzählen"]},
    {"to eat": ["essen", "esse", "isst", "isst", "isst", "isst", "essen", "esst", "essen", "essen"]},
    {"to remember": ["erinnern", "erinnere", "erinnerst", "erinnert", "erinnert", "erinnert", "erinnern", "erinnert", "erinnern", "erinnern"]},
    {"to work": ["arbeiten", "arbeite", "arbeitest", "arbeitet", "arbeitet", "arbeitet", "arbeiten", "arbeitet", "arbeiten", "arbeiten"]},
    {"to learn": ["lernen", "lerne", "lernst", "lernt", "lernt", "lernt", "lernen", "lernt", "lernen", "lernen"]},
    {"to live": ["leben", "lebe", "lebst", "lebt", "lebt", "lebt", "leben", "lebt", "leben", "leben"]},
    {"to love": ["lieben", "liebe", "liebst", "liebt", "liebt", "liebt", "lieben", "liebt", "lieben", "lieben"]},
    {"to read": ["lesen", "lese", "liest", "liest", "liest", "liest", "lesen", "lest", "lesen", "lesen"]},
    {"to write": ["schreiben", "schreibe", "schreibst", "schreibt", "schreibt", "schreibt", "schreiben", "schreibt", "schreiben", "schreiben"]},
    {"to see": ["sehen", "sehe", "siehst", "sieht", "sieht", "sieht", "sehen", "seht", "sehen", "sehen"]},
    {"to sleep": ["schlafen", "schlafe", "schläfst", "schläft", "schläft", "schläft", "schlafen", "schlaft", "schlafen", "schlafen"]},
    {"to speak": ["sprechen", "spreche", "sprichst", "spricht", "spricht", "spricht", "sprechen", "sprecht", "sprechen", "sprechen"]},
    {"to understand": ["verstehen", "verstehe", "verstehst", "versteht", "versteht", "versteht", "verstehen", "versteht", "verstehen", "verstehen"]},
    {"to wait": ["warten", "warte", "wartest", "wartet", "wartet", "wartet", "warten", "wartet", "warten", "warten"]},
    {"to come": ["kommen", "komme", "kommst", "kommt", "kommt", "kommt", "kommen", "kommt", "kommen", "kommen"]},
    {"to go": ["gehen", "gehe", "gehst", "geht", "geht", "geht", "gehen", "geht", "gehen", "gehen"]},
    {"to have": ["haben", "habe", "hast", "hat", "hat", "hat", "haben", "habt", "haben", "haben"]},
    {"to be": ["sein", "bin", "bist", "ist", "ist", "ist", "sind", "seid", "sind", "sind"]},
    {"to do": ["machen", "mache", "machst", "macht", "macht", "macht", "machen", "macht", "machen", "machen"]},
    {"to give": ["geben", "gebe", "gibst", "gibt", "gibt", "gibt", "geben", "gebt", "geben", "geben"]},
    {"to take": ["nehmen", "nehme", "nimmst", "nimmt", "nimmt", "nimmt", "nehmen", "nehmt", "nehmen", "nehmen"]},
    {"to say": ["sagen", "sage", "sagst", "sagt", "sagt", "sagt", "sagen", "sagt", "sagen", "sagen"]},
    {"to find": ["finden", "finde", "findest", "findet", "findet", "findet", "finden", "findet", "finden", "finden"]},
    {"to know": ["wissen", "weiß", "weißt", "weiß", "weiß", "weiß", "wissen", "wisst", "wissen", "wissen"]},
    {"to become": ["werden", "werde", "wirst", "wird", "wird", "wird", "werden", "werdet", "werden", "werden"]},
    {"to stay": ["bleiben", "bleibe", "bleibst", "bleibt", "bleibt", "bleibt", "bleiben", "bleibt", "bleiben", "bleiben"]},
    {"to want": ["wollen", "will", "willst", "will", "will", "will", "wollen", "wollt", "wollen", "wollen"]},
    {"to can": ["können", "kann", "kannst", "kann", "kann", "kann", "können", "könnt", "können", "können"]},
    {"to must": ["müssen", "muss", "musst", "muss", "muss", "muss", "müssen", "müsst", "müssen", "müssen"]},
    {"to should": ["sollen", "soll", "sollst", "soll", "soll", "soll", "sollen", "sollt", "sollen", "sollen"]},
    {"to may": ["dürfen", "darf", "darfst", "darf", "darf", "darf", "dürfen", "dürft", "dürfen", "dürfen"]},
    {"to like": ["mögen", "mag", "magst", "mag", "mag", "mag", "mögen", "mögt", "mögen", "mögen"]},
    {"to would like": ["möchten", "möchte", "möchtest", "möchte", "möchte", "möchte", "möchten", "möchtet", "möchten", "möchten"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Ecke ist dunkel.',
        english: 'The corner is dark.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ehefrau ist nett.',
        english: 'The wife is nice.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ehemann arbeitet.',
        english: 'The husband works.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Ei ist frisch.',
        english: 'The egg is fresh.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Eingang ist offen.',
        english: 'The entrance is open.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Einladung kommt.',
        english: 'The invitation comes.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Eintritt kostet fünf Euro.',
        english: 'The admission costs five euros.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Einzelzimmer ist frei.',
        english: 'The single room is free.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Eltern sind hier.',
        english: 'The parents are here.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ E-Mail ist wichtig.',
        english: 'The email is important.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Empfänger wartet.',
        english: 'The recipient waits.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Ende ist nah.',
        english: 'The end is near.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Entschuldigung hilft.',
        english: 'The apology helps.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ergebnis ist gut.',
        english: 'The result is good.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Erwachsene spricht.',
        english: 'The adult speaks.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Essen ist fertig.',
        english: 'The meal is ready.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Erfahrung ist wichtig.',
        english: 'The experience is important.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ehepaar tanzt.',
        english: 'The married couple dances.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Einkauf war teuer.',
        english: 'The purchase was expensive.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Elefant ist groß.',
        english: 'The elephant is big.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Motor läuft.',
        english: 'The engine runs.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Beispiel ist klar.',
        english: 'The example is clear.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Wirtschaft wächst.',
        english: 'The economy grows.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Bildung ist wichtig.',
        english: 'The education is important.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Strom ist aus.',
        english: 'The electricity is out.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Gefühl ist stark.',
        english: 'The emotion is strong.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Energie ist hoch.',
        english: 'The energy is high.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ingenieur arbeitet.',
        english: 'The engineer works.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Umschlag ist leer.',
        english: 'The envelope is empty.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Umwelt ist sauber.',
        english: 'The environment is clean.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Fehler ist klein.',
        english: 'The error is small.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Ereignis war wichtig.',
        english: 'The event was important.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Abend ist schön.',
        english: 'The evening is beautiful.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Prüfung ist schwer.',
        english: 'The exam is difficult.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Übung hilft.',
        english: 'The exercise helps.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ausgang ist links.',
        english: 'The exit is on the left.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Experte antwortet.',
        english: 'The expert answers.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Erklärung ist klar.',
        english: 'The explanation is clear.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Ausdruck ist schön.',
        english: 'The expression is beautiful.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Auge ist blau.',
        english: 'The eye is blue.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Ohr hört gut.',
        english: 'The ear hears well.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Erde ist rund.',
        english: 'The earth is round.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Osten ist weit.',
        english: 'The east is far.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Feind kommt.',
        english: 'The enemy comes.',
        answer: 'Der',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Ecke.',
        english: 'I see the corner.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er liebt ___ Ehefrau.',
        english: 'He loves the wife.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Sie besucht ___ Ehemann.',
        english: 'She visits the husband.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir brauchen ___ Ei.',
        english: 'We need the egg.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Du öffnest ___ Eingang.',
        english: 'You open the entrance.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich schreibe ___ Einladung.',
        english: 'I write the invitation.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er bezahlt ___ Eintritt.',
        english: 'He pays the admission.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie bucht ___ Einzelzimmer.',
        english: 'She books the single room.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir besuchen ___ Eltern.',
        english: 'We visit the parents.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du schreibst ___ E-Mail.',
        english: 'You write the email.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Ich sehe ___ Empfänger.',
        english: 'I see the recipient.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie erreicht ___ Ende.',
        english: 'She reaches the end.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Er hört ___ Entschuldigung.',
        english: 'He hears the apology.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir bekommen ___ Ergebnis.',
        english: 'We get the result.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Du siehst ___ Erwachsene.',
        english: 'You see the adult.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich koche ___ Essen.',
        english: 'I cook the meal.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie braucht ___ Erfahrung.',
        english: 'She needs the experience.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir gratulieren ___ Ehepaar.',
        english: 'We congratulate the married couple.',
        answer: 'dem',
        case: 'accusative'
      },
      {
        german: 'Du machst ___ Einkauf.',
        english: 'You make the purchase.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er füttert ___ Elefant.',
        english: 'He feeds the elephant.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie repariert ___ Motor.',
        english: 'She repairs the engine.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich verstehe ___ Beispiel.',
        english: 'I understand the example.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir studieren ___ Wirtschaft.',
        english: 'We study the economy.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du bekommst ___ Bildung.',
        english: 'You get the education.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Strom.',
        english: 'He needs the electricity.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie zeigt ___ Gefühl.',
        english: 'She shows the emotion.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir brauchen ___ Energie.',
        english: 'We need the energy.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du rufst ___ Ingenieur an.',
        english: 'You call the engineer.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich öffne ___ Umschlag.',
        english: 'I open the envelope.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie schützt ___ Umwelt.',
        english: 'She protects the environment.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir finden ___ Fehler.',
        english: 'We find the error.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du besuchst ___ Ereignis.',
        english: 'You attend the event.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich genieße ___ Abend.',
        english: 'I enjoy the evening.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie macht ___ Prüfung.',
        english: 'She takes the exam.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir machen ___ Übung.',
        english: 'We do the exercise.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du suchst ___ Ausgang.',
        english: 'You look for the exit.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich frage ___ Experte.',
        english: 'I ask the expert.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie hört ___ Erklärung.',
        english: 'She hears the explanation.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir verstehen ___ Ausdruck.',
        english: 'We understand the expression.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du wäschst ___ Auge.',
        english: 'You wash the eye.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Er putzt ___ Ohr.',
        english: 'He cleans the ear.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie liebt ___ Erde.',
        english: 'She loves the earth.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir sehen ___ Osten.',
        english: 'We see the east.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du bekämpfst ___ Feind.',
        english: 'You fight the enemy.',
        answer: 'den',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich stehe in ___ Ecke.',
        english: 'I stand in the corner.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er hilft ___ Ehefrau.',
        english: 'He helps the wife.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Sie spricht mit ___ Ehemann.',
        english: 'She speaks with the husband.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir geben Kind ___ Ei.',
        english: 'We give the child an egg.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du wartest bei ___ Eingang.',
        english: 'You wait at the entrance.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich danke für ___ Einladung.',
        english: 'I thank for the invitation.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Er bezahlt für ___ Eintritt.',
        english: 'He pays for the admission.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Sie schläft in ___ Einzelzimmer.',
        english: 'She sleeps in the single room.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir helfen ___ Eltern.',
        english: 'We help the parents.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Du antwortest auf ___ E-Mail.',
        english: 'You answer the email.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Ich gebe ___ Empfänger ___ Brief.',
        english: 'I give the recipient the letter.',
        answer: 'dem den',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet bis ___ Ende.',
        english: 'She works until the end.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er akzeptiert ___ Entschuldigung.',
        english: 'He accepts the apology.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Wir warten auf ___ Ergebnis.',
        english: 'We wait for the result.',
        answer: 'das',
        case: 'dative'
      },
      {
        german: 'Du sprichst mit ___ Erwachsene.',
        english: 'You speak with the adult.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich koche für ___ Essen.',
        english: 'I cook for the meal.',
        answer: 'das',
        case: 'dative'
      },
      {
        german: 'Sie lernt von ___ Erfahrung.',
        english: 'She learns from the experience.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Wir gratulieren ___ Ehepaar.',
        english: 'We congratulate the married couple.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du bezahlst mit ___ Einkauf.',
        english: 'You pay with the purchase.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er füttert ___ Elefant.',
        english: 'He feeds the elephant.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet mit ___ Motor.',
        english: 'She works with the engine.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich folge ___ Beispiel.',
        english: 'I follow the example.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir arbeiten in ___ Wirtschaft.',
        english: 'We work in the economy.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du investierst in ___ Bildung.',
        english: 'You invest in education.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Er verbindet mit ___ Strom.',
        english: 'He connects with electricity.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie spricht über ___ Gefühl.',
        english: 'She speaks about the emotion.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir haben wegen ___ Energie.',
        english: 'We have because of energy.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du arbeitest mit ___ Ingenieur.',
        english: 'You work with the engineer.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich stecke Brief in ___ Umschlag.',
        english: 'I put the letter in the envelope.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Sie kämpft für ___ Umwelt.',
        english: 'She fights for the environment.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Wir lachen über ___ Fehler.',
        english: 'We laugh about the error.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du erinnerst an ___ Ereignis.',
        english: 'You remember the event.',
        answer: 'das',
        case: 'dative'
      },
      {
        german: 'Ich warte auf ___ Abend.',
        english: 'I wait for the evening.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Sie hat Angst vor ___ Prüfung.',
        english: 'She is afraid of the exam.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Wir machen bei ___ Übung.',
        english: 'We participate in the exercise.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Ausgang.',
        english: 'You go to the exit.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich frage ___ Experte.',
        english: 'I ask the expert.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie versteht ___ Erklärung.',
        english: 'She understands the explanation.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Wir übersetzen ___ Ausdruck.',
        english: 'We translate the expression.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Du schützt ___ Auge.',
        english: 'You protect the eye.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er putzt ___ Ohr.',
        english: 'He cleans the ear.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie lebt auf ___ Erde.',
        english: 'She lives on the earth.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Wir reisen in ___ Osten.',
        english: 'We travel to the east.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Du wehrst dich gegen ___ Feind.',
        english: 'You defend against the enemy.',
        answer: 'den',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The corner is dark.',
        german: 'Die Ecke ist dunkel.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The wife is nice.',
        german: 'Die Ehefrau ist nett.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The husband works.',
        german: 'Der Ehemann arbeitet.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The egg is fresh.',
        german: 'Das Ei ist frisch.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The entrance is open.',
        german: 'Der Eingang ist offen.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The invitation comes.',
        german: 'Die Einladung kommt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The admission costs five euros.',
        german: 'Der Eintritt kostet fünf Euro.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The single room is free.',
        german: 'Das Einzelzimmer ist frei.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The parents are here.',
        german: 'Die Eltern sind hier.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The email is important.',
        german: 'Die E-Mail ist wichtig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The end is near.',
        german: 'Das Ende ist nah.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The apology helps.',
        german: 'Die Entschuldigung hilft.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The result is good.',
        german: 'Das Ergebnis ist gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The meal is ready.',
        german: 'Das Essen ist fertig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The experience is important.',
        german: 'Die Erfahrung ist wichtig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I shop for groceries.',
        german: 'Ich kaufe ein.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'She invites you.',
        german: 'Sie lädt dich ein.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'He gets on the train.',
        german: 'Er steigt in den Zug ein.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'We recommend this restaurant.',
        german: 'Wir empfehlen dieses Restaurant.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'The lesson ends.',
        german: 'Die Stunde endet.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'I apologize.',
        german: 'Ich entschuldige mich.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'She explains the problem.',
        german: 'Sie erklärt das Problem.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'He allows smoking.',
        german: 'Er erlaubt das Rauchen.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'I tell a story.',
        german: 'Ich erzähle eine Geschichte.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'We eat together.',
        german: 'Wir essen zusammen.',
        type: 'translation',
        caseType: 'verb'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to shop" for "I"?',
        answer: 'kaufe ein',
        verb: 'einkaufen',
        verbEnglish: 'to shop',
        subject: 'ich',
        conjugation: 'kaufe ein'
      },
      {
        question: 'How do you conjugate "to shop" for "you" (informal)?',
        answer: 'kaufst ein',
        verb: 'einkaufen',
        verbEnglish: 'to shop',
        subject: 'du',
        conjugation: 'kaufst ein'
      },
      {
        question: 'How do you conjugate "to shop" for "he/she/it"?',
        answer: 'kauft ein',
        verb: 'einkaufen',
        verbEnglish: 'to shop',
        subject: 'er/sie/es',
        conjugation: 'kauft ein'
      },
      {
        question: 'How do you conjugate "to invite" for "I"?',
        answer: 'lade ein',
        verb: 'einladen',
        verbEnglish: 'to invite',
        subject: 'ich',
        conjugation: 'lade ein'
      },
      {
        question: 'How do you conjugate "to invite" for "you" (informal)?',
        answer: 'lädst ein',
        verb: 'einladen',
        verbEnglish: 'to invite',
        subject: 'du',
        conjugation: 'lädst ein'
      },
      {
        question: 'How do you conjugate "to get in" for "I"?',
        answer: 'steige ein',
        verb: 'einsteigen',
        verbEnglish: 'to get in',
        subject: 'ich',
        conjugation: 'steige ein'
      },
      {
        question: 'How do you conjugate "to recommend" for "I"?',
        answer: 'empfehle',
        verb: 'empfehlen',
        verbEnglish: 'to recommend',
        subject: 'ich',
        conjugation: 'empfehle'
      },
      {
        question: 'How do you conjugate "to recommend" for "you" (informal)?',
        answer: 'empfiehlst',
        verb: 'empfehlen',
        verbEnglish: 'to recommend',
        subject: 'du',
        conjugation: 'empfiehlst'
      },
      {
        question: 'How do you conjugate "to recommend" for "he"?',
        answer: 'empfiehlt',
        verb: 'empfehlen',
        verbEnglish: 'to recommend',
        subject: 'er',
        conjugation: 'empfiehlt'
      },
      {
        question: 'How do you conjugate "to end" for "I"?',
        answer: 'ende',
        verb: 'enden',
        verbEnglish: 'to end',
        subject: 'ich',
        conjugation: 'ende'
      },
      {
        question: 'How do you conjugate "to excuse" for "I"?',
        answer: 'entschuldige',
        verb: 'entschuldigen',
        verbEnglish: 'to excuse',
        subject: 'ich',
        conjugation: 'entschuldige'
      },
      {
        question: 'How do you conjugate "to explain" for "I"?',
        answer: 'erkläre',
        verb: 'erklären',
        verbEnglish: 'to explain',
        subject: 'ich',
        conjugation: 'erkläre'
      },
      {
        question: 'How do you conjugate "to allow" for "I"?',
        answer: 'erlaube',
        verb: 'erlauben',
        verbEnglish: 'to allow',
        subject: 'ich',
        conjugation: 'erlaube'
      },
      {
        question: 'How do you conjugate "to allow" for "you" (informal)?',
        answer: 'erlaubst',
        verb: 'erlauben',
        verbEnglish: 'to allow',
        subject: 'du',
        conjugation: 'erlaubst'
      },
      {
        question: 'How do you conjugate "to allow" for "he"?',
        answer: 'erlaubt',
        verb: 'erlauben',
        verbEnglish: 'to allow',
        subject: 'er',
        conjugation: 'erlaubt'
      },
      {
        question: 'How do you conjugate "to tell" for "I"?',
        answer: 'erzähle',
        verb: 'erzählen',
        verbEnglish: 'to tell',
        subject: 'ich',
        conjugation: 'erzähle'
      },
      {
        question: 'How do you conjugate "to tell" for "you" (informal)?',
        answer: 'erzählst',
        verb: 'erzählen',
        verbEnglish: 'to tell',
        subject: 'du',
        conjugation: 'erzählst'
      },
      {
        question: 'How do you conjugate "to tell" for "he"?',
        answer: 'erzählt',
        verb: 'erzählen',
        verbEnglish: 'to tell',
        subject: 'er',
        conjugation: 'erzählt'
      },
      {
        question: 'How do you conjugate "to eat" for "I"?',
        answer: 'esse',
        verb: 'essen',
        verbEnglish: 'to eat',
        subject: 'ich',
        conjugation: 'esse'
      },
      {
        question: 'How do you conjugate "to eat" for "you" (informal)?',
        answer: 'isst',
        verb: 'essen',
        verbEnglish: 'to eat',
        subject: 'du',
        conjugation: 'isst'
      },
      {
        question: 'How do you conjugate "to eat" for "he"?',
        answer: 'isst',
        verb: 'essen',
        verbEnglish: 'to eat',
        subject: 'er',
        conjugation: 'isst'
      },
      {
        question: 'How do you conjugate "to eat" for "we"?',
        answer: 'essen',
        verb: 'essen',
        verbEnglish: 'to eat',
        subject: 'wir',
        conjugation: 'essen'
      }
    ]
  }
}
